import { Component, Input, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators,  FormGroupDirective } from '@angular/forms'

@Component({
    selector: 'app-form-text-area',
    templateUrl: 'form-text-area.html'
})
export class FormTextAreaComponent implements OnInit {

    @Input() label: string = 'Write something'
    @Input() value: string | undefined = ''
    @Input() placeholderText: string = ''
    @Input() fieldId: string = 'textarea'
    @Input() darkTheme: boolean = false
    @Input() required: boolean = true
    @Input() modifierClassname: string
    @Input() useMinWidth = false
    @Input() minHeight: string = '80px'

    form: FormGroup

    constructor(private rootFormGroup: FormGroupDirective) {}

    ngOnInit(): void {
        this.form = this.rootFormGroup.control;

        const validators = [
            this.required ? Validators.required : null
        ].filter(Boolean)

        this.form.addControl(
            this.fieldId, 
            new FormControl(this.value, validators)
        )
    }

    get control(){
        return this.form.get(this.fieldId)
    }
    
}
